import { useCallback, useState } from 'react';

import { LIST_VIEW_TYPE } from '~/shared/constants';

const useItemsNavigator = ({ fetchMore, viewType }) => {
  const [listViewType, setViewType] = useState(viewType ?? LIST_VIEW_TYPE.TILE);
  const [sort, setSortByOrder] = useState('_ID_DESC');
  const onPageClick = useCallback(
    (selection: { selected: number }) => {
      if (fetchMore) {
        fetchMore({ nextPage: selection.selected, sort });
      }
    },
    [sort, fetchMore],
  );
  const setSort = useCallback(
    async (newSort: string) => {
      setSortByOrder(newSort);

      if (newSort !== sort && fetchMore) {
        await fetchMore({ nextPage: 1, sort });
      }
    },
    [setSortByOrder, sort],
  );

  return { listViewType, setSort, sort, onPageClick, setViewType };
};

export default useItemsNavigator;
